import React from "react";
import {Button, Grid, TextField, useTheme} from "@material-ui/core";
import Rest from "../../helpers/Rest";
import logo from "../../images/Sonasafe_R_214x74.png";
import useStyles from "./styles"
import ProgressOr from "../../components/ProgressOr";
import {Validator, notEmpty} from "../../helpers/Validator";

let loginPath = "/"

function setLoginPath(path){
    if (path){
        loginPath = path;
    }
    else {
        const href = /#(.+)/.exec(window.location.href)
        if (href){
            const path = href[1]
            if (!/^\/login(?:$|\?)/.test(path)){
                loginPath = path
            }
        }
        else{
            loginPath = "/"
        }
    }
}

class LoginImpl extends React.Component{
    constructor(props) {
        super(props);
        this.validator = new Validator()
        this.validator.add('username', notEmpty, false)
        this.validator.add('password', notEmpty, false)
        this.state = {
            username: '',
            password: '',
            loading: false,
            failed: false
        }
    }

    setField(name, e){
        const val = e.target.value
        this.validator.check(name, val)
        const state = {}
        state[name] = val;
        this.setState(state)
    }

    setUsername(e){
        this.setField('username', e)
    }

    setPassword(e){
        this.setField('password', e)
    }

    login(){
        this.setState({
            loading: true,
            failed: false
        })
        Rest.login(this.state.username, this.state.password).then((user) => {
            console.log("Forwarding to " + loginPath)
            this.props.history.replace(loginPath)
        }).catch((error) => {
            this.setState({
                loading: false,
                failed: true
            })
            console.log(error)
        })
    }

    errorMessage(){
        if (this.state.failed){
            return (
                <div className={this.props.classes.loginFailed}>
                    Login failed
                </div>
            )
        }
        return ""
    }

    render(){
        return (
            <div className={this.props.classes.outer}>
                <img src={logo} alt="Sonasafe" />
                {this.errorMessage()}
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            error={this.validator.displayError("username")}
                            label="User name"
                            value={this.state.username}
                            onChange={this.setUsername.bind(this)}
                            variant="outlined"
                            size="small"
                            autoComplete="off"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            error={this.validator.displayError("password")}
                            label="Password"
                            value={this.state.password}
                            type="password"
                            onChange={this.setPassword.bind(this)}
                            variant="outlined"
                            size="small"
                            autoComplete="new-password"
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <ProgressOr showProgress={this.state.loading} progressMessage="Authenticating...">
                            <Button
                                disabled={this.validator.disableSubmit}
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={this.login.bind(this)}
                            >
                                Login
                            </Button>
                        </ProgressOr>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

function Login(props){
    const classes = useStyles(useTheme())
    return <LoginImpl classes={classes} {...props}/>
}

export {Login, setLoginPath}
